const resolveDefaultOpt = (defaultOpt = {}) => {
  const defaultOption = {
    grade: {},
    area: {},
    school: {},
    company: {}
  }
  const newOption = Object.assign(defaultOption, defaultOpt)
  return {
    userGrade: newOption.grade.gradeName || "",
    userArea: newOption.area.name || "",
    userSchool: newOption.school.schoolName || "",
    userCompany: newOption.company.companyName || ""
  }
}

export default resolveDefaultOpt
